import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-956255b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main--rain-panel" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "main--rain-panel__meter" }, null, -1))
const _hoisted_3 = { class: "main--rain-panel__controller" }
const _hoisted_4 = { class: "main--rain-panel__controller__time-slider rain-slider" }
const _hoisted_5 = { class: "main--rain-panel__controller__speed-slider rain-slider" }
const _hoisted_6 = { class: "main--rain-panel__controller__timer" }
const _hoisted_7 = { class: "rain-time" }
const _hoisted_8 = { class: "controls" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Slider = _resolveComponent("Slider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Slider, {
          max: _ctx.MAX_SLIDER_VALUE,
          modelValue: _ctx.sliderValue,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.sliderValue) = $event)),
          style: {"width":"345px","margin-left":"-7px","margin-top":"4px"}
        }, null, 8, ["max", "modelValue"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_Slider, {
          max: 100,
          min: 30,
          modelValue: _ctx.speed,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.speed) = $event)),
          style: {"width":"95px","margin-left":"-2px","margin-top":"-4px"}
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.displayTime), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          id: "rain-panel__autoplay",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleAutoPlay()))
        }),
        (_ctx.autoplay)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              id: "rain-panel__pause",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleAutoPlay()))
            }))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          id: "rain-panel__btn__prev",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.rainTimePrev()))
        }),
        _createElementVNode("button", {
          id: "rain-panel__btn__next",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.rainTimeNext()))
        })
      ])
    ])
  ]))
}